import { Injectable } from '@angular/core';

import { WebApiModel } from '../../models/web-api.model';

@Injectable()
export class FootnoteService {
  private _footnotes: string[] = [];

  getFootnotes(): string[] {
    return this._footnotes;
  }

  /**
   * Initialises the person profile footnotes so parent and child components can access them.
   * There might be multiple footnotes on the profile page some belong to the person and some to places.
   */
  initPersonFootnotes(person: WebApiModel.Person): string[] {
    this._footnotes = [];

    if (person.notes) {
      this.addFootnote(person.notes);
    }

    if (person.places && person.places.length > 0) {
      person.places.forEach((place) => {
        if (place.notes) {
          this.addFootnote(place.notes);
        }
      });
    }

    return this._footnotes;
  }

  /**
   * Initialises place profile footnotes.
   */
  initPlaceFootnotes(place: WebApiModel.Place): string[] {
    this._footnotes = [];

    if (place.notes) {
      this.addFootnote(place.notes);
    }

    if (place.people && place.people.length > 0) {
      place.people.forEach((person) => {
        if (person.notes) {
          this.addFootnote(person.notes);
        }
      });
    }

    return this._footnotes;
  }

  /**
   * Adds a footnote to an array which keeps the state of the footnotes on the current profile page.
   */
  private addFootnote(text: string) {
    const index = this._footnotes.indexOf(text);

    if (index === -1) {
      this._footnotes.push(text);
      return new Footnote(this._footnotes.length, text);
    }

    return null; // Ensure a value is always returned
  }

  /**
   * Returns a footnote index and text so it can be rendered in the UI.
   */
  getFootnote(text: string): Footnote {
    const index = this._footnotes.indexOf(text);

    if (index > -1) {
      return new Footnote(index + 1, text);
    } else {
      return null;
    }
  }
}

export class Footnote {
  constructor(
    public index: number,
    public text: string,
  ) {}
}
